import React from 'react';
import { Icon } from 'antd';

import moment from 'moment';

import commonStore from '../../../../../stores/commonStore';

export default (text, record) => {
  return text ? (
    <div>
      <Icon type="heart" className={`${text} ${(record.shutdown === true) ? 'shutdown' : 'noshutdown'}`} />
      {text === 'disconnected' && <div>{moment(record.lastConnection || record.createdAt).format(commonStore.longDateFormat.L)}</div>}
    </div>
  ) : (
    <span>&mdash;</span>
  );
};
